import styled from '@emotion/styled';
import { ITheme } from '../../themer';
import themed from '../../themer/themed';

export const ShimmerPlaceholder = styled.div<{}, ITheme>`
	background: ${themed(({ shimmer }) => shimmer.placeholder.background)};
	border-radius: ${themed(({ shimmer }) => shimmer.placeholder.borderRadius)};
`;
